import { isAllowed } from '../cmp/utils';

export const LocalStorageUtils = {
  read: key => {
    try {
      return isAllowed('localStorage', key)
        ? JSON.parse(localStorage.getItem(key))
        : null;
    } catch (err) {
      return null;
    }
  },

  create: (key, value) => {
    try {
      if (isAllowed('localStorage', key)) {
        localStorage.setItem(key, JSON.stringify(value));
      }
    } catch (err) {
      // Ignore
    }
  },

  erase: key => {
    try {
      if (isAllowed('localStorage', key)) {
        localStorage.removeItem(key);
      }
    } catch (err) {
      // Ignore
    }
  },
};
